"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WordWriteLockNotice = exports.WORD_WRITE_LOCK_MESSAGE = void 0;
var _react = _interopRequireDefault(require("react"));
var _useWordWriteLockHeld = require("../../hooks/use-word-write-lock-held");
var _Banner = _interopRequireDefault(require("./Banner"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var WORD_WRITE_LOCK_MESSAGE = exports.WORD_WRITE_LOCK_MESSAGE = "Write lock on: edits you start yourself wait until this batch finishes.";
var WordWriteLockNotice = exports.WordWriteLockNotice = function WordWriteLockNotice(_ref) {
  var holds = _ref.holds;
  var isWriteLockHeld = (0, _useWordWriteLockHeld.useWordWriteLockHeld)(holds);
  if (!isWriteLockHeld) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    role: "status",
    "aria-live": "polite",
    "data-sentry-component": "WordWriteLockNotice",
    "data-sentry-source-file": "WordWriteLockNotice.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Banner.default, {
      type: "info",
      message: WORD_WRITE_LOCK_MESSAGE,
      "data-sentry-element": "Banner",
      "data-sentry-source-file": "WordWriteLockNotice.tsx"
    })
  });
};